import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 3.5H1.5V7.81818H11V3.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.5 9.81818V14.1818H11V9.81818H1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.5 16.1818V20.5H11V16.1818H1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 20.5H22.5V16.1818H13V20.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 14.1818V9.81818H13V14.1818H22.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 7.81818V3.5H13V7.81818H22.5Z"}}]};

const Table2Filled = Vue.extend<IconProps>({
  name: 'Table2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'table-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Table2Filled;
